import { TCreateSendSettingsPatch } from '../../../types/createSendSettings';

export const PATCH_CS_SEND_SETTINGS = 'PATCH_CS_SEND_SETTINGS';

export const patchCsSendSettings = (payload: TCreateSendSettingsPatch) => ({
  type: PATCH_CS_SEND_SETTINGS,
  payload,
});
